/**
 * Mario warp-pipe cart icon.
 *
 * Inline SVG — no external dep. Pure 90s arcade green, matches the
 * storefront's chunky outlined aesthetic (3-px navy stroke to harmonise
 * with the buttons + product cards).
 */
const WarpPipeCart = ({ size = 28, className = '', 'data-testid': testId }) => {
  const w = size;
  const h = size;
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      data-testid={testId}
    >
      {/* Pipe body (the long shaft going down) */}
      <rect x="10" y="18" width="28" height="26" fill="#3DD12F" stroke="#0A0A2E" strokeWidth="3" />
      {/* Highlight stripe on the left of the body */}
      <rect x="12.5" y="20" width="4" height="22" fill="#A6F0A0" />
      {/* Shadow strip on the right of the body */}
      <rect x="33" y="20" width="3" height="22" fill="#1C8F19" />

      {/* Pipe lip (the wider top rim) */}
      <rect x="4" y="10" width="40" height="10" fill="#3DD12F" stroke="#0A0A2E" strokeWidth="3" />
      {/* Highlight on the lip */}
      <rect x="6.5" y="12" width="6" height="6" fill="#A6F0A0" />
      {/* Shadow on the right of the lip */}
      <rect x="36" y="12" width="5" height="6" fill="#1C8F19" />
    </svg>
  );
};

export default WarpPipeCart;
